import { AppShell, Box, MediaQuery, Stack, Text, Title } from '@mantine/core'
import { useTranslations } from 'next-intl'
import PropTypes from 'prop-types'
import styles from '../../styles/Home.module.css'
import Footer from './footer.js'
import Navbar from './navbar'

const Hero = ({ title, subtitle }) => {
  return (
    <div className={styles.backgroundContainer}>
      <div className={styles.backgroundBlur}></div>

      <div className={styles.backgroundOverlay}></div>

      <div className={styles.overlay}></div>

      <MediaQuery smallerThan="sm" styles={{ display: 'none' }}>
        <Stack
          sx={{
            position: 'relative',
            height: '300px',
            zIndex: 2
          }}
          align="center"
          justify="center"
        >
          <Stack w="100%" maxw={800} spacing={20} align="center">
            <Title size={60} mt={30} align="center" className={styles.hero}>
              {title}
            </Title>
            <Text
              size="lg"
              align="center"
              sx={{
                zIndex: 3,
                textShadow: 'rgba(255,255,255,0.5) 0px 0px 10px'
              }}
            >
              {subtitle}
            </Text>
          </Stack>
        </Stack>
      </MediaQuery>

      <MediaQuery largerThan="sm" styles={{ display: 'none' }}>
        <Stack
          sx={{
            position: 'relative',
            height: '320px',
            padding: '0 20px',
            zIndex: 2
          }}
          align="center"
          justify="center"
        >
          <Stack spacing={10} align="center" w="100%">
            <Title size={36} mt={10} align="center" className={styles.hero}>
              {title}
            </Title>
          </Stack>
        </Stack>
      </MediaQuery>
    </div>
  )
}

export default function Layout({
  children,
  withAutocomplete = false,
  showSearchBar = true,
  showHero,
  heroSubtitle,
  pageName
}) {
  const t = useTranslations(pageName)
  return (
    <Box>
      <AppShell
        padding={0}
        navbar={
          <Navbar
            withAutocomplete={withAutocomplete}
            showSearchBar={showSearchBar}
          />
        }
        footer={<Footer />}
      >
        <div className={styles.backgroundContainer}>
          <div className={styles.backgroundBlur}></div>

          <div className={styles.backgroundOverlay}></div>

          <div className={styles.overlay}></div>
        </div>
        {/* {showHero && (
          <Hero
            title={t('heroTitle')}
            subtitle={heroSubtitle || t('heroSubtitle')}
          />
        )} */}
        {children}
      </AppShell>
    </Box>
  )
}

Layout.propTypes = {
  children: PropTypes.node,
  withAutocomplete: PropTypes.bool,
  showSearchBar: PropTypes.bool,
  showHero: PropTypes.bool,
  heroTitle: PropTypes.string,
  heroSubtitle: PropTypes.node
}
